/**
 * @Copyright (c) 2021 DigiNet
 * @author NHATLONG
 * @create 13/9/2021
 * @Example
 */


export const types = {
    W09F2282_GET_FORM: "W09F2282_GET_FORM",
};

export function getForm(params, cb) {
    return {
        type: types.W09F2282_GET_FORM,
        params,
        cb,
    };
}
